module.exports = __webpack_public_path__ + "img/pond-head.77a5f265.png";